import {
  faCheckCircle,
  faTimesCircle
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { startCase } from "lodash";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import i18n, { Ti18nKeys } from "../../../constants/i18n";
import { getReadableDateFromUnixMilliseconds } from "../../../helpers/et3-date-helper";
import getCorePopUpStore from "../../../stores/core/core-popup-store";
import getTransferUserPackageStore from "../../../stores/developer-store/transfer-user-package-store";
import { TTransferConsumableCount } from "../../../Types";
import ET3Div from "../../et3-div";
import Et3Text from "../../et3-text";

const TransferUserPackagePopUp = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const fromUserId = getTransferUserPackageStore().fromUserId.get();
  const toUserId = getTransferUserPackageStore().toUserId.get();
  const packageType = getTransferUserPackageStore().selectedPackageType.get();
  const preview = getTransferUserPackageStore().preview.get();

  const renderDetailRow = (label: string, value: string) => (
    <ET3Div
      key={label}
      isScrollable={false}
      isExtendable={true}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={860}
      height={40}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={18}
        text={label}
        isSpan={false}
        color={colors.all.black}
        style={{ width: 560 * unitX }}
      />
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={18}
        text={value}
        isSpan={false}
        color={colors.all.black}
        style={{ width: 280 * unitX, textAlign: "right" }}
      />
    </ET3Div>
  );

  const renderConsumablesSection = (
    titleKey: Ti18nKeys,
    counts: TTransferConsumableCount[]
  ) => (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={860}
      height={60}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={20}
        text={i18n.get(titleKey)}
        isSpan={false}
        color={colors.all.black}
        style={{ width: 860 * unitX }}
      />
      {counts.length === 0
        ? renderDetailRow(i18n.get("TRANSFER_PACKAGE_NO_CONSUMABLES"), "")
        : counts.map((entry) =>
            renderDetailRow(startCase(entry.featureCode), entry.count)
          )}
    </ET3Div>
  );

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={1080}
      fDirection="row"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{
        position: "fixed",
        top: 0,
        zIndex: 5
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={true}
        isExtendable={true}
        fDirection="column"
        justifyContent="space-between"
        alignItems="center"
        withShadow={true}
        width={1000}
        height={700}
        color={colors.all.white}
        style={{
          position: "relative",
          borderRadius: 50,
          zIndex: 5
        }}
        onClick={() => {}}
      >
        <Et3Text
          fontFamily={"BOLD"}
          fontSize={24}
          text={i18n.getWithArrayExtraData(
            "TRANSFER_USER_PACKAGE_CONFIRMATION_POPUP",
            [`${fromUserId}`, `${toUserId}`, packageType]
          )}
          isSpan={false}
          color={colors.all.black}
          style={{ width: 900 * unitX }}
        />

        {renderDetailRow(
          i18n.get("TRANSFER_PACKAGE_CURRENT_EXPIRY"),
          getReadableDateFromUnixMilliseconds(preview.currentExpiry)
        )}
        {renderDetailRow(
          i18n.get("TRANSFER_PACKAGE_NEW_EXPIRY"),
          getReadableDateFromUnixMilliseconds(preview.newExpiry)
        )}

        {renderConsumablesSection(
          "TRANSFER_PACKAGE_REMAINING_QUOTAS",
          preview.remainingQuotas
        )}
        {renderConsumablesSection(
          "TRANSFER_PACKAGE_REMAINING_BALANCES",
          preview.remainingBalances
        )}

        <ET3Div
          isScrollable={false}
          isExtendable={true}
          fDirection="row"
          justifyContent="space-between"
          alignItems="center"
          withShadow={false}
          width={500}
          height={100}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <FontAwesomeIcon
            className="clickable"
            onClick={async () => {
              await getTransferUserPackageStore().transferUserPackage();
            }}
            icon={faCheckCircle}
            color={colors.all.green}
            style={{}}
            size="3x"
          />
          <FontAwesomeIcon
            className="clickable"
            onClick={() => {
              getCorePopUpStore().closeConfirmationPopUps();
            }}
            icon={faTimesCircle}
            color={colors.all.red}
            style={{}}
            size="3x"
          />
        </ET3Div>
      </ET3Div>
    </ET3Div>
  );
});
export default TransferUserPackagePopUp;
